export default __webpack_public_path__ + "static/media/conclave-event.d900ea96.jpeg";